import { Branch } from "../model/Branch";
import { getLogger } from "@goodgamestudios/logger";

const logger = getLogger("WorldAssignment.BranchesManager");

export class BranchesManager {
    private _currentBranch: Branch;
    public branches: Branch[] = [];

    /**
     * Return branch for given zone id, if not found, the defaul branch will be returned, if defaul branch is not present,
     * return null.
     * @param zoneId zone id
     */
    public getBranchByZoneId(zoneId: string): Branch {
        logger.debug("BranchesManager.getBranchByZoneId: ", zoneId);
        let branch: Branch;
        let defaultBranch: Branch = null;
        for (let i = 0; i < this.branches.length; i++) {
            branch = this.branches[i];
            logger.debug("looping branch: ", branch.zones);
            if (branch.zones.indexOf(zoneId) > -1) {
                return branch;
            }
            if(!defaultBranch && branch.id === "default") {
                defaultBranch = branch;
            }
        }
        return defaultBranch;
    }

    public getBranchByBranchId(branchId: string): Branch {
        let branch: Branch;
        for (let i = 0; i < this.branches.length; i++) {
            branch = this.branches[i];
            if (branch.id === branchId) {
                return branch;
            }
        }
        return null;
    }

    public set currentBranch(branch: Branch) {
        this._currentBranch = branch;
    }

    public get currentBranch(): Branch {
        return this._currentBranch;
    }
}
